import React, {Component} from 'react';

import './IndexHeader.scss';

class IndexHeader extends Component {
    
    render() {
        return (
            <div className="IndexHeader">
                <div className="container">
                    <div className="IndexHeader-leftItem">
                        <div className="IndexHeader-title">
                            Более <span className="IndexHeader-titleNumber">130 000</span> машин
                        </div>
                        <div className="IndexHeader-description">
                            с надежными перевозчиками
                        </div>
                    </div>
                    <div className="IndexHeader-rightItem">
                        <div className="IndexHeader-title">
                            Сравните цены
                        </div>
                        <div className="IndexHeader-description">
                            за 40 секунд
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IndexHeader;



// WEBPACK FOOTER //
// ./client/components/IndexHeader/IndexHeader.js